/* istanbul ignore file */
import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import { EventsMap } from '@noths/polaris-client-next-redux';
import { Product } from '@noths/polaris-dev-ts-types';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { getFieldObjectList, getProductFieldObject } from 'src/utils/googleAnalytics';
import { getProductClickTrackingEvent } from '../../../../tracking/events/productClick';
import { productListClick } from '../modules/actions';

export const GAEventsMap: EventsMap<ReduxApplicationState> = {
  [productListClick.type]: (state, _nextState, action) => {
    const {
      payload: { productCode, productUrl, destinationUrl, linkOpensInSameWindow },
    } = action as ReturnType<typeof productListClick>;

    const { items, productsReturnedCount, category, searchTerm } = state.products;
    const { pageType } = state.navigation;

    const clickedProduct = Object.keys(items)
      .reduce((curr, key) => curr.concat(items[key]), [] as Product[])
      .find((prod) => prod.code === productCode)!;

    const event = getProductClickTrackingEvent({
      eventCategory: 'Product listings',
      destinationUrl,
      eventLabel: 'null',
      actionFieldList: getFieldObjectList(
        clickedProduct,
        category,
        searchTerm,
        pageType,
        clickedProduct.isExpandedSearch ? ' - expanded' : undefined,
      ),
      products: [
        getProductFieldObject(clickedProduct, items, productsReturnedCount, category, pageType),
      ],
    });

    sendGAEvent(event).then(() => {
      if (linkOpensInSameWindow) {
        window.location.assign(productUrl);
      }
    });
  },
};
